// Szzt's HTTPS compatibility deployment chooses its own route vocabulary. This
// is NOT the shared ATW standard's unsettled NSID. Generic route writers/readers
// still take an explicit collection; changing this value is a namespace migration.
export const SZZT_HTTPS_ROUTE_COLLECTION = "app.szzt.route";
